// extracted by mini-css-extract-plugin
export default {"addBtn":"NewItemBtn_addBtn__DCAA7","right":"NewItemBtn_right__P-VU+"};